import { api } from "@/lib/api";

export const lastKey = (kind) => `itp_last_${kind}`;
export const getLast = (kind) => localStorage.getItem(lastKey(kind));
export const setLast = (kind, id) => (id ? localStorage.setItem(lastKey(kind), id) : localStorage.removeItem(lastKey(kind)));

export const listProjects = (kind) => api.get("/projects", { params: { kind } }).then((r) => r.data.projects);
export const createProject = (kind, name, data, meta) => api.post("/projects", { kind, name, data, meta }).then((r) => r.data);
export const getProject = (id) => api.get(`/projects/${id}`).then((r) => r.data);
export const updateProject = (id, patch) => api.put(`/projects/${id}`, patch).then((r) => r.data);
export const duplicateProject = (id) => api.post(`/projects/${id}/duplicate`).then((r) => r.data);
export const deleteProject = (id) => api.delete(`/projects/${id}`).then((r) => r.data);

export const CH = 600_000;
export async function uploadLayer(pid, layerId, dataUrl) {
  const total = Math.ceil(dataUrl.length / CH);
  for (let i = 0; i < total; i++) await api.post(`/projects/${pid}/layer`, { layer_id: layerId, index: i, total, chunk: dataUrl.slice(i * CH, (i + 1) * CH) });
}
